import { useMemo, useState } from 'react';
import WorkCard from '@/components/base/WorkCard';
import { works } from '@/mocks/works';
import type { WorkType } from '@/types';

const tabs: { key: 'all' | WorkType; label: string }[] = [
  { key: 'all', label: '全部' },
  { key: 'movie', label: '电影' },
  { key: 'tv', label: '电视剧' },
];

export default function HotRecommend() {
  const [active, setActive] = useState<'all' | WorkType>('all');

  const list = useMemo(() => {
    const filtered = active === 'all' ? works : works.filter((w) => w.type === active);
    return [...filtered].sort((a, b) => a.rank - b.rank).slice(0, 8);
  }, [active]);

  return (
    <div>
      <div className="mb-6 inline-flex items-center gap-1 rounded-full bg-secondary-100 p-1">
        {tabs.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setActive(t.key)}
            className={`cursor-pointer rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
              active === t.key ? 'bg-primary-500 text-background-50' : 'text-secondary-900 hover:bg-secondary-200'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {list.length === 0 ? (
        <div className="rounded-lg border border-background-200 bg-background-100 py-16 text-center text-foreground-500">
          暂无相关内容，敬请期待
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-6 lg:grid-cols-4">
          {list.map((w, i) => (
            <WorkCard key={w.id} work={w} rank={i + 1} />
          ))}
        </div>
      )}
    </div>
  );
}